/**
 * Таблица защищённых маршрутов admin-app.
 *
 * Config-driven: добавление нового экрана = одна запись здесь. Все маршруты
 * оборачиваются в AppShell + PlatformAdminGuard (см. App.tsx).
 */
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { OnboardingWizardPage } from '../features/onboarding/OnboardingWizardPage.js';
import { HotelsListPage } from '../features/hotels/HotelsListPage.js';
import { HotelDetailPage } from '../features/hotels/HotelDetailPage.js';
import { SubscriptionsPage } from '../features/subscriptions/SubscriptionsPage.js';
import { RbacPage } from '../features/rbac/RbacPage.js';
import { CapabilitiesPage } from '../features/capabilities/CapabilitiesPage.js';
import { AuditPage } from '../features/audit/AuditPage.js';
import { VendorsPage } from '../features/vendors/VendorsPage.js';
import { ReviewsPage } from '../features/reviews/ReviewsPage.js';
import { HealthPage } from '../features/health/HealthPage.js';
import { ReportsPage } from '../features/reports/ReportsPage.js';
import { SettingsPage } from '../features/settings/SettingsPage.js';

export interface RouteDef {
  path: string;
  Element: () => JSX.Element;
}

export const PROTECTED_ROUTES: ReadonlyArray<RouteDef> = [
  { path: '/dashboard', Element: DashboardPage },
  { path: '/onboarding', Element: OnboardingWizardPage },
  { path: '/hotels', Element: HotelsListPage },
  { path: '/hotels/:id', Element: HotelDetailPage },
  { path: '/subscriptions', Element: SubscriptionsPage },
  { path: '/rbac', Element: RbacPage },
  { path: '/capabilities', Element: CapabilitiesPage },
  { path: '/audit', Element: AuditPage },
  { path: '/vendors', Element: VendorsPage },
  { path: '/reviews', Element: ReviewsPage },
  { path: '/health', Element: HealthPage },
  { path: '/reports', Element: ReportsPage },
  { path: '/settings', Element: SettingsPage },
];
